import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Computer Science Projects`}</h2>
    <ProjectCard title="thor𝜓vos- The all-in-one cryptographic toolkit" link="https://pypi.org/project/thoryvos/" bg="linear-gradient(to right, #c21919 12%, #960835 95%)" mdxType="ProjectCard">
All-in-one cryptographic toolkit with file encryption/decryption, audio steganography, and anonymous file sharing. All with a functional yet intuitive GUI, easy to use CLI, and can be used as a python module.
    </ProjectCard>
    <ProjectCard title="EmoCh- Emotion Analysis from Speech" link="https://github.com/freakingrocky/EmoCh" bg="linear-gradient(to top, #373B44 0%, #4286f4 100%)" mdxType="ProjectCard">
It uses the tonal qualities of speech to determine the person's emotions. It is intended for use in voice-only scenarios.
    </ProjectCard>
    <ProjectCard title="Autonomous Driving AI using Reinforcement Learning in Carla" link="https://github.com/freakingrocky/CarlaRLAI" bg="linear-gradient(to right, #6c9e10 12%, #0e8f51 96%)" mdxType="ProjectCard">
AI in the CARLA Self-Driving Environment that uses Reinforcement Learning. I've used sensor fusion to combine DVS, RGB, and depth sensors mitigate motion blur and for better adaptability to drastic conditions such as rain, low-light, etc.
    </ProjectCard>
    <ProjectCard title="Unbeatable Tic-Tac-Toe AI (Click To Play!)" link="https://freakingrocky.github.io/TicTacToe/" bg="linear-gradient(to bottom, #ffa600 0%, #3c5900 100%)" mdxType="ProjectCard">
This is an Unbeatable Tic-Tac-Toe AI agent. The AI calculates the score of every "possible world" and makes a move with the highest future score.
    </ProjectCard>
    <h2>{`Music`}</h2>
    <ProjectCard title="My Band" link="https://www.krystallicpurge.com/music" bg="linear-gradient(to bottom, #000000 0%, #434343 98%)" mdxType="ProjectCard">
Krystallic Purge was founded in 2019. We are a progressive metal, alternative rock band.<br />
Check us out!
    </ProjectCard>
    <ProjectCard title="Covers/Concerts" link="https://www.youtube.com/playlist?list=PLC2vg8Wluh4Q0XLIsRHBFKTQpjfMMz8uO" bg="linear-gradient(to top, #403B4A 0%, #3A6073 100%)" mdxType="ProjectCard">
These are my guitar covers and live concerts on youtube.<br />
Sorry for the video quality of some of these in advance.
    </ProjectCard>
    <h2>{`Other Stuff`}</h2>
    <ProjectCard title="Github" link="https://www.github.com/freakingrocky" bg="linear-gradient(to bottom, #E6DADA 0%, #274046 100%)" mdxType="ProjectCard">
Check out my Github profile
    </ProjectCard>
    <ProjectCard title="LinkedIn" link="https://www.linkedin.com/in/rakshan-sharma/" bg="linear-gradient(to top, #8360c3 0%, #2ebf91 100%)" mdxType="ProjectCard">
Check out my LinkedIn
    </ProjectCard>
    <ProjectCard title="Online Courses" link="/courses" bg="linear-gradient(to bottom, #66ff00 0%, #a80077 100%)" mdxType="ProjectCard">
A list of online courses I've completed and received a certificate for.
    </ProjectCard>
    <ProjectCard title="ARMGDNLive" link="https://armgdnlive.com" bg="linear-gradient(to bottom, #03001e 0%, #7303c0 33%, #ec38bc 66%, #fdeff9 100%)" mdxType="ProjectCard">
The goal of the organization is to bring a new revenue stream- online concerts -to indie artists.<br /> I am the Co-Founder/President.</ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      